<script setup lang="ts">
type Props = {
  media: object
  title: string
  theme?: string
}

const _props = withDefaults(defineProps<{ data: Props; isEducation?: boolean }>(), {
  isEducation: false,
})

const { isMobileOrTablet } = useDevice()
const { width: innerWidth } = useWindowSize()

const isMobile = computed(() => {
  if (import.meta.server) return isMobileOrTablet
  return innerWidth.value < 900
})

const locale = useI18n().locale
</script>

<template>
  <div
    class="relative bg-(--theme-bg) text-(--theme-fg) lg:h-screen"
    :class="'theme-' + data?.theme"
  >
    <ElementsThemeSetter :theme="data?.theme" :is-hero="true" />

    <div v-if="data?.media" class="background absolute inset-0 h-full w-full">
      <CommonMedia
        v-if="data?.media"
        :media="data?.media"
        class="h-full w-full object-cover"
        :sizes="'xs:100vw sm:100vw md:100vw lg:100vw xl:100vw xxl:100vw'"
      />
      <div class="overlay absolute inset-0 h-full w-full bg-black opacity-10" />
    </div>

    <div class="relative flex aspect-square flex-col pb-0 lg:aspect-auto lg:h-full">
      <h1
        class="font-display mt-auto text-center leading-[0.65]"
        :class="
          locale === 'da'
            ? isEducation
              ? 'text-[15.4vw]'
              : 'text-[17.4vw]'
            : isEducation
              ? 'text-[18.4vw]'
              : 'text-[12.4vw]'
        "
      >
        <CommonExposedText
          v-if="isMobile && data.title"
          :text="data.title"
          :exposure="[-40, -80]"
          :animated="true"
        />
        <CommonProximityText
          v-else-if="data.title"
          :text="data.title"
          :radius="700"
          falloff="easeInOut"
          :exposure="{ from: -20, to: -80 }"
        />
      </h1>
    </div>
  </div>
</template>
